<template>
  <f7-list-item class="ripple" style="overflow: hidden;" :title="question.title + question.option.toString()" @click.stop="toggleSwitch">
    <font-awesome-icon
      slot="after"
      icon="check"
      style="color: #FFFFFF; border-radius: 2px;"
      :style="{
        border: question.value ? 'none' : 'solid 1px #888888',
        background: question.value ? '#4CAF50' : '#FFFFFF',
        padding: question.value ? '2px' : '1px'
      }" />
  </f7-list-item>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Question from './Question'

export default {
  name: 'SwitchQuestion',
  dependencies: [
    'platformUtils',
    'CartElementBuilder'
  ],
  data () {
    return {
      pickerOpen: false
    }
  },
  beforeCreate: function () {
    // circular reference
    this.$options.components.Question = Question
  },
  computed: {
    ...mapGetters(['currentMenu']),
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionId, this.itemObj, this.currentMenu)
    }
  },
  props: {
    questionId: {},
    itemObj: Object
  },
  methods: {
    ...mapActions('itemModule', [
      'setQuestion'
    ]),
    toggleSwitch () {
      this.setQuestion({
        itemId: this.itemObj.id,
        itemInstanceId: this.itemObj.instanceId,
        questionId: this.questionId,
        value: !this.question.value,
        itemBucket: this.itemObj.itemBucket
      })
    }
  }
}
</script>
